import AxiosStatic from "axios";
class VersionService {
  $http = AxiosStatic;

  getVersion() {
    return this.$http.get("/api/Version/Index");
  }
}

export default new VersionService();
